/* Tucann empty-cart helper (2026-10-25): the Kaching drawer's empty state has no way out. Add a Continue shopping button + Bestsellers. */
(function () {
  var cache = null, pending = false;
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(src) { if (!src) return ''; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=400'; }
  function money(v) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    if (cur !== 'USD') return '';
    var n = parseFloat(v); if (isNaN(n)) return '';
    return '$' + (n % 1 ? n.toFixed(2) : n.toFixed(0));
  }
  function html(products) {
    var cards = products.map(function (p) {
      var v = p.variants && p.variants[0];
      return '<a class="tp-ec__card" href="/products/' + esc(p.handle) + '"><span class="tp-ec__im"><img loading="lazy" width="400" height="500" alt="' + esc(p.title) + '" src="' + esc(img(p.images && p.images[0] && p.images[0].src)) + '"></span><span class="tp-ec__t">' + esc(p.title) + '</span><span class="tp-ec__p">' + esc(v ? money(v.price) : '') + '</span></a>';
    }).join('');
    return '<div class="tp-ec tp-ec--drawer"><a class="button tp-ec__cta" href="/collections/all">Continue shopping</a><h2 class="tp-ec__h">Bestsellers</h2><div class="tp-ec__grid">' + cards + '</div></div>';
  }
  function put(box, products) {
    if (box.querySelector('.tp-ec')) return;
    box.insertAdjacentHTML('beforeend', html(products));
  }
  function run() {
    var box = document.querySelector('kaching-cart-drawer .kaching-cart__empty-cart-content');
    if (!box || box.querySelector('.tp-ec')) return;
    if (cache) { put(box, cache); return; }
    if (pending) return; pending = true;
    fetch('/collections/best-sellers/products.json?limit=8').then(function (r) { return r.json(); }).then(function (d) {
      cache = (d.products || []).filter(function (p) { return p.variants && p.variants.some(function (v) { return v.available; }); }).slice(0, 4);
      pending = false;
      var b = document.querySelector('kaching-cart-drawer .kaching-cart__empty-cart-content');
      if (b && cache.length) put(b, cache);
    }).catch(function () { pending = false; });
  }
  var raf = 0;
  new MutationObserver(function () {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = 0; run(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
